// {{size}} and {{duration}} come from formatVideoLimits, {{length}} from formatVideoLength.
export const VIDEO_TRANSLATION_DEFAULTS: Record<string, string> = {
  'video.choose_file': 'Choose video',
  'video.hint': 'MP4, MOV, M4V, or WebM, up to {{size}}, {{duration}} max',
  'video.uploading': 'Uploading…',
  'video.processing': 'Finishing up…',
  'video.cancel': 'Cancel',
  'video.retry': 'Try again',
  'video.remove': 'Remove video',
  'video.play': 'Play video',
  'video.close': 'Close',
  'video.choose_thumbnail': 'Choose thumbnail',
  'video.thumbnail_dialog': 'Select a thumbnail',
  'video.thumbnail_frame': 'Frame',
  'video.upload_thumbnail': 'Upload custom thumbnail',
  'video.thumbnail_error': "Couldn't update the thumbnail.",
  'video.error_unsupported': 'That file type is not supported.',
  'video.error_empty': 'That file is empty.',
  'video.error_too_large': 'Video is larger than {{size}}.',
  'video.error_too_long': 'This video is {{length}} long. Videos can be up to {{duration}}.',
  'video.error_transfer': 'The upload was interrupted.',
  'video.error_completion': 'The upload finished but could not be saved.',
  'video.status_processing': 'Processing video…',
  'video.status_ready': 'Video ready',
  'video.status_ready_to_publish': 'Ready to publish',
  'video.status_failed': 'Video processing failed.',
  'video.status_blocked': 'This video was blocked.',
  'video.failed_too_long': 'Video is longer than {{duration}}.',
  'video.failed_resolution_too_high': 'Video resolution is too high.',
  'video.failed_unreadable': "This file can't be read as a video.",
  'video.remove_to_post': 'Remove the video to post.',
  'video.unavailable': 'This video is unavailable right now.',
  'video.placeholder': 'Video',
};

export const tr = (translations: Record<string, string> | undefined, key: string): string =>
  translations?.[key] ?? VIDEO_TRANSLATION_DEFAULTS[key] ?? key;
